import { gql, useSubscription } from "@apollo/client";
import { isAuthenticated } from "@src/auth/auth-utils";
import { useUserProfile } from "@src/components/user/user-context";
import { useRef } from "react";

export const onWhatsAppConnectedSubscription = gql`
	subscription OnWhatsAppConnected {
		onWhatsAppConnected {
			phoneNumber
			userId
		}
	}
`;

export interface WhatsAppConnectedPayload {
	phoneNumber: string;
	userId: string;
}

export interface WhatsAppConnectedSubscriptionData {
	onWhatsAppConnected: WhatsAppConnectedPayload;
}

export interface UseWhatsAppConnectedSubscriptionOptions {
	onConnected?: (payload: WhatsAppConnectedPayload) => void;
	skip?: boolean;
}

export function useWhatsAppConnectedSubscription(
	options?: UseWhatsAppConnectedSubscriptionOptions,
) {
	const { user } = useUserProfile();
	const [, setUser] = user;
	const optionsRef = useRef(options);
	optionsRef.current = options;

	useSubscription<WhatsAppConnectedSubscriptionData>(
		onWhatsAppConnectedSubscription,
		{
			skip: options?.skip || !isAuthenticated(),
			onData: (result) => {
				const subscriptionData = result.data?.data ?? result.data;
				const payload =
					subscriptionData && "onWhatsAppConnected" in subscriptionData
						? subscriptionData.onWhatsAppConnected
						: undefined;
				if (payload?.phoneNumber) {
					setUser({ phoneNumber: payload.phoneNumber });
					optionsRef.current?.onConnected?.(payload);
				}
			},
			onError: (error) => {
				console.warn("WhatsApp connected subscription error:", error);
			},
		},
	);
}
